import { useSelector } from 'react-redux';

import { getGeoCountry } from './intlModule';

export default function useGeoCountry() {
  return useSelector(getGeoCountry);
}
